import { useNavigate, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import AppShell from "@/components/AppShell";

export default function PaymentCancel() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const orderId = params.get("order_id");

  return (
    <AppShell>
      <div className="px-4 md:px-8 lg:px-12 py-16 max-w-xl mx-auto text-center">
        <div className="mx-auto h-24 w-24 rounded-3xl bg-red-100 text-red-600 flex items-center justify-center">
          <XCircle className="h-12 w-12" />
        </div>
        <h1 className="mt-8 text-4xl font-bold text-gray-900 tracking-tight">Payment cancelled</h1>
        <p className="mt-3 text-gray-600">Your order is still saved. You can retry payment anytime from the Orders page.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <button onClick={() => nav("/orders")} className="px-6 py-3 rounded-full bg-emerald-600 text-white font-semibold">Go to Orders</button>
          <button onClick={() => nav("/marketplace")} className="px-6 py-3 rounded-full border border-gray-200">Browse more</button>
        </div>
      </div>
    </AppShell>
  );
}
